import { render, staticRenderFns } from "./print.vue?vue&type=template&id=424a52f5&scoped=true&"
import script from "./print.vue?vue&type=script&lang=ts&"
export * from "./print.vue?vue&type=script&lang=ts&"
import style0 from "./print.vue?vue&type=style&index=0&id=424a52f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a52f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VIcon})
